module.exports = __webpack_public_path__ + "img/ia07.a927d8c4.png";